import useCreateRealPlaySessionMutation from 'features/realplays/services/mutations/useCreateRealPlaySession';
import useUpdateRealPlaySessionStatusMutation from 'features/realplays/services/mutations/useUpdateRealplaySessionStatus';
import useUploadRecordingMutation from 'features/realplays/services/mutations/useUploadRecording';
import useCreatePublicRealPlaySessionMutation from 'features/publicRoleplay/services/mutations/useCreatePublicRealplaySession';
import useUpdateRealPlayPublicSessionStatusMutation from 'features/publicRoleplay/services/mutations/useUpdateRealplayPublicSessionStatus';
import useUploadPublicRecordingFileMutation from 'features/publicRoleplay/services/mutations/useUploadPublicRecordingFile';
const RecordVideoServicesLogic = () => {
  //normalService
  const { mutate: startSession, isLoading: isLoadingNormalSession } =
    useCreateRealPlaySessionMutation();
  const { mutate: updateSession } = useUpdateRealPlaySessionStatusMutation();
  const { mutate: uploadTempVideo } = useUploadRecordingMutation();

  //publicService
  const { mutate: startPublicSession, isLoading: isLoadingPublicSession } =
    useCreatePublicRealPlaySessionMutation();
  const { mutate: updatePublicSession } = useUpdateRealPlayPublicSessionStatusMutation();
  const { mutate: uploadPublicTempVideo } = useUploadPublicRecordingFileMutation();

  return {
    startSession,
    isLoadingNormalSession,
    updateSession,
    uploadTempVideo,
    startPublicSession,
    isLoadingPublicSession,
    updatePublicSession,
    uploadPublicTempVideo,
  };
};

export default RecordVideoServicesLogic;
